import React from 'react';
import PropTypes from 'prop-types';
import Svg from '../../Svg';
import upperCaseFirst from 'upper-case-first';
import classNames from 'classnames';

const Option = (props) => {
    function getOptionDisplayName() {
        return props.displayName || upperCaseFirst(props.value);
    }

    return (
        <li
            className={classNames(
                'ui-filter__option',
                {
                    'ui-filter__option_selected': props.selected
                }
            )}
            onClick={() => props.onOptionClick(props.value)}
        >
            <span className="ui-filter__link ui-popoverList__link">
                <span className="ui-popoverList__label">{getOptionDisplayName()}</span>
                <span className="ui-filter__icon">
                    <Svg size="Medium" iconName="tick" />
                </span>
            </span>
        </li>
    );
};

Option.propTypes = {
    value: PropTypes.number.isRequired,
    onOptionClick: PropTypes.func.isRequired,
    displayName: PropTypes.string,
    selected: PropTypes.bool
};

export default Option;



// WEBPACK FOOTER //
// ./src/js/modules/Dropdown/components/Option.js